import { GraphQLClient } from 'graphql-request';
import { Query, QueryGraphDataPointsInGroupArgs, QueryGraphNetWorthArgs } from '../generated/graphql';
import { gql } from 'urql';
import { MonetaryAmountFragment } from './fragments';

export const getGraphNetWorthQuery = gql`
  ${MonetaryAmountFragment}
  query graphNetWorth($householdID: ID!, $settings: GraphSettings) {
    graphNetWorth(householdID: $householdID, settings: $settings) {
      __typename
      dateTime
      interpolated
      value {
        __typename
        ... on MonetaryAmountGraphPointValue {
          value {
            ...MonetaryAmountFragment
          }
        }
      }
    }
  }
`;

export const graphNetWorthQuery = async (client: GraphQLClient, args: QueryGraphNetWorthArgs) => {
  return (await client.request<Pick<Query, 'graphNetWorth'>, QueryGraphNetWorthArgs>(getGraphNetWorthQuery, args))
    .graphNetWorth;
};

export const clientGetGraphDataPoints = async (client: GraphQLClient, args: QueryGraphDataPointsInGroupArgs) => {
  return (
    await client.request<Pick<Query, 'graphDataPointsInGroup'>>(
      gql`
        query GraphDataPointsInGroup($tenantID: ID!, $groupID: ID!, $settings: GraphSettings) {
          graphDataPointsInGroup(tenantID: $tenantID, groupID: $groupID, settings: $settings) {
            __typename
            dateTime
            interpolated
            value {
              __typename
              ... on MonetaryAmountGraphPointValue {
                value {
                  value
                  currencyCode
                }
              }
            }
          }
        }
      `,
      {
        ...args,
      }
    )
  ).graphDataPointsInGroup;
};
